import { useEffect } from "react";

const ConvertKitScript = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.async = true;
    script.src = "//insights-tag.convertkit.com/tag/aZB9QG.js";

    const firstScript = document.getElementsByTagName("script")[0];
    firstScript.parentNode.insertBefore(script, firstScript);

    return () => {
      // Clean up the script when the component is unmounted
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return null; // No visual output
};

export default ConvertKitScript;
